// TagMarquee.tsx
import React, { useEffect, useRef, useState } from 'react';
import styles from './TagMarquee.module.css';   // same CSS file – keep the classes

type Props = {
  tags: string[];        // array coming from typeProject
  speed?: number;                  // seconds for one full loop (optional)
};

const TagMarquee: React.FC<Props> = ({ tags, speed = 5 }) => {
    
    const containerRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);
    const [shouldAnimate, setShouldAnimate] = useState(false);
    const [animationName, setAnimationName] = useState<string | null>(null);

    useEffect(() => {
        const container = containerRef.current;
        const content = contentRef.current;

        if (!container || !content) return;

        const containerWidth = container.clientWidth;
        const contentWidth = content.scrollWidth;

        const isOverflowing = contentWidth > containerWidth;
        setShouldAnimate(isOverflowing);

        if (isOverflowing) {
        const animationId = `scrollMarquee-${Math.floor(Math.random() * 100000)}`;
        const styleTag = document.createElement('style');

        styleTag.innerHTML = `
            @keyframes ${animationId} {
            0% {
                transform: translateX(0);
            }
            100% {
                transform: translateX(-${contentWidth}px);
            }
            }
        `;

        document.head.appendChild(styleTag);
        setAnimationName(animationId);

        return () => {
            // Cleanup if unmounted or re-rendered
            document.head.removeChild(styleTag);
        };
        }
    }, []);

    return (
            <div className={styles.marqueeContainer}  ref={containerRef}>
                <div className={`${styles.marqueeContent} ${shouldAnimate ? styles.animate : ''}`} ref={contentRef}
                    style={{
                        animation: shouldAnimate && animationName
                            ? `${animationName} 5s linear infinite`
                            : undefined,
                    }}
                >
                    <>
                    {tags.map((typeObj, index) => (
                        <span key={`tag1-${index}`} className={styles.tag}>{typeObj}</span>
                    ))}
                    {/* Duplicate for seamless loop */}
                        {shouldAnimate && (
                            <>
                                {tags.map((typeObj, index) => (
                                    <span key={`tag2-${index}`} className={styles.tag}>{typeObj}</span>
                                ))}
                            </>
                        )}
                    </>
                </div>
            </div>
    );
};

export default TagMarquee;
